export const SET_USERNAME = "SET_USERNAME";
export const SET_LOGIN_STATE = "SET_LOGIN_STATE";
export const SET_UID = "SET_UID";
export const SET_SERVER_LIST = "SET_SERVER_LIST";
export const SET_DEFAULT_SERVER = "SET_DEFAULT_SERVER";
export const SET_ROLE_INDEX = "SET_ROLE_INDEX";
export const SET_DEFAULT_ROLE = "SET_DEFAULT_ROLE";
export const mutations = {
  [SET_USERNAME](state, username) {
    state.username = username;
    window["accountName"] = username;
    try {
      window.__updatePointUploadCookie("login_account", username);
    } catch (e) {
      console.log(e);
    }
  },
  [SET_UID](state, uid) {
    state.uid = uid;
    try {
      window.__updatePointUploadCookie("uid", uid);
    } catch (e) {
      console.log(e);
    }
  },
  [SET_LOGIN_STATE](state, loginState) {
    state.isLogin = loginState;
  },

  [SET_ROLE_INDEX](state, roleIndex) {
    state.roleIndex = roleIndex;
  },
  [SET_DEFAULT_SERVER](state, defaultServer) {
    state.serverList[0] = defaultServer;
  },
  [SET_DEFAULT_ROLE](state, defaultRole) {
    state.roleList[0] = defaultRole;
  },
};
